import React, {Component} from 'react'
import {Media} from '../../components';
import {TweenMax, Power4} from "gsap/TweenMax";
import classNames from 'classnames'

class Carousel extends Component {

  len=0;
  auto="";
  intervalObj = 9;

  constructor(props) {
    super(props);

    this.state = {

      currentSlide:0,
      currentSlideOut: 0,
      nextSlide: 1,
      nextSlideIn: 1,
      time: 3000,
      controls: false,
      autoStop: false
      
    };

    this.onClick = this.onClick.bind(this);
   
  }

  componentDidMount() {

      this.len = this.props.count-1;//this.props.images.length-1;

      if(this.props.auto) {
        this.auto = setInterval(this.auto,this.state.time);  
      } else {
        this.auto();
      }
      

  };

  componentWillUnmount() {
    clearInterval(this.auto);
  }

  // intervalManager = (flag) => {
  

  //   if(flag) {
  //     console.log('if');
  //     if(this.intervalObj === 9) {
  //       clearInterval(this.intervalObj);
  //       this.intervalObj = setInterval(this.auto,this.state.time);  
  //     }      
  //   } else {
  //     console.log('else');
  //     this.intervalObj = 9;
      
  //     clearInterval(this.intervalObj);
  //   }

  //   console.log('this.intervalObj', this.intervalObj);
  // }

  auto = () => {
    
    let _this = this;
    let currentSlide = (this.state.currentSlide < this.len) ? this.state.currentSlide+1 : 0;
    let nextSlide = (currentSlide == _this.len) ? 0 : currentSlide+1;

    this.setState({currentSlide:currentSlide, nextSlide: nextSlide, currentSlideOut: -1, nextSlideIn: -1});

    setTimeout(function() {  
      _this.setState({currentSlideOut:currentSlide, nextSlideIn: nextSlide})  
    },(this.state.time/4));
    

  }

  onClick = (direction) => {
    console.log('direction', direction, this.len);
    
    clearInterval(this.auto);
    
    let _this = this;
    let currentSlide;
    let nextSlide;

    if(direction === 'next') {
      currentSlide = (this.state.currentSlide < this.len) ? this.state.currentSlide+1 : 0;
      nextSlide = (currentSlide == _this.len) ? 0 : currentSlide+1;  
    } else {

      if(this.state.currentSlide === 0) {
        currentSlide = this.len;
      } else {
        currentSlide = this.state.currentSlide-1;
      }

      nextSlide = (currentSlide == _this.len) ? 0 : currentSlide-1;  

    }
    
    let timer = 2000;


    this.setState({ currentSlide:currentSlide, nextSlide: nextSlide, controls: false, currentSlideOut: -1, nextSlideIn: -1, autoStop: true })
   
    
  }


  render () { 

      let _this = this;
      const { path,count,ratio } = this.props;     
      const p = (100 / ratio)+"%";
      const controlsLength = count//images.length;
      let images = this.props.images;


      const style = {
        paddingTop: p
      }

    
      return (
          
        <div className="Carousel" style={style} >
            
          <div className="Carousel-container">
            <div className="Carousel-images">
              
              { images.map((img,ix) => {
                
                let cur = (ix == this.state.currentSlide) ? "current " : "";
                let next = (ix == this.state.nextSlide) ? "next " : ""; 

                return(

                  <div className={"Carousel-image-container "+cur+next} key={ix}>
    
                      <div className={"Carousel-image"} key={ix} ><Media src={img.url} fluid={false} ratio={false} /></div>                      
            
                  </div>

                );
              }) }
            </div>

            { this.props.controls && <div className="Carousel-controls">

              <div className="Carousel-control Carousel-control--prev" onClick={ () => { this.onClick('prev') } }><span>Prev</span></div>
              <div className="Carousel-control Carousel-control--next" onClick={ () => { this.onClick('next') } }><span>Next</span></div>

            </div> }

          </div>

        </div>

      );

  }
}

export default Carousel



// WEBPACK FOOTER //
// ./src/js/components/Carousel/Carousel.js